import { KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";

/**
 * Shared sensor config for dnd-kit sortable lists. The pointer activation
 * distance ensures that short clicks on cards (used to navigate to edit) are
 * not interpreted as drag gestures.
 */
export const useSortableSensors = () => {
    const pointerSensor = useSensor(PointerSensor, {
        activationConstraint: { distance: 3 },
    });
    const keyboardSensor = useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates,
    });
    return useSensors(pointerSensor, keyboardSensor);
};
